import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate, TextFormat } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './message-table.reducer';

export const MessageTableDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const messageTableEntity = useAppSelector(state => state.messageTable.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="messageTableDetailsHeading">
          <Translate contentKey="reachamyApp.messageTable.detail.title">MessageTable</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{messageTableEntity.id}</dd>
          <dt>
            <span id="message">
              <Translate contentKey="reachamyApp.messageTable.message">Message</Translate>
            </span>
          </dt>
          <dd>{messageTableEntity.message}</dd>
          <dt>
            <span id="createdBy">
              <Translate contentKey="reachamyApp.messageTable.createdBy">Created By</Translate>
            </span>
          </dt>
          <dd>{messageTableEntity.createdBy}</dd>
          <dt>
            <span id="createdAt">
              <Translate contentKey="reachamyApp.messageTable.createdAt">Created At</Translate>
            </span>
          </dt>
          <dd>
            {messageTableEntity.createdAt ? <TextFormat value={messageTableEntity.createdAt} type="date" format={APP_DATE_FORMAT} /> : null}
          </dd>
          <dt>
            <span id="modifiedBy">
              <Translate contentKey="reachamyApp.messageTable.modifiedBy">Modified By</Translate>
            </span>
          </dt>
          <dd>{messageTableEntity.modifiedBy}</dd>
          <dt>
            <span id="modifiedAt">
              <Translate contentKey="reachamyApp.messageTable.modifiedAt">Modified At</Translate>
            </span>
          </dt>
          <dd>
            {messageTableEntity.modifiedAt ? (
              <TextFormat value={messageTableEntity.modifiedAt} type="date" format={APP_DATE_FORMAT} />
            ) : null}
          </dd>
        </dl>
        <Button tag={Link} to="/message-table" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/message-table/${messageTableEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default MessageTableDetail;
